import { Table } from "antd"
import "./todo-list.less"
import { useEffect, useState } from "react";
import { EditableCell, EditableRow } from "@/baseui/editable-cell";
import { Task } from "@/declare/interface/task";
import { updateTask } from "@/declare/api/task";

interface IProps {
    todoList: Task[]
    projectName?: string
    setTodoList: (tasks: Task[]) => void
}

export default function MeetingMinuteTodoList(props: IProps) {

    const { todoList } = props

    const [cellSelected, setCellSelected] = useState<string>(); // 单元格选中

    const handleSave = (row: Task, key) => {
        if (key === "title") {
            updateTask(row.id, row);   //修改任务名称    
            let newTodoList = todoList.map((item) => {
                if(item.id === row.id) {
                    item.title = row.title;
                }
                return item;
            });    
            props.setTodoList(newTodoList);
        }
    }

    return (
        <div className="meeting-todo-list-main">
            <Table
                dataSource={todoList}
                bordered={true}
                pagination={false}
                size="middle"
                className="todo-list-table"
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{y: 'calc(100vh - 48px - 75px - 8px - 16px - 36px - 41px - 32px - 29px - 70px)'}}
            >

                <Table.Column title="项目" dataIndex="projectId" width={150}
                    render={(value: number, row: Task) => {
                        return props.projectName || ""
                    }}
                    onCell={(record: Task, idx) => {
                        return {
                            record,
                            editable: false,
                            dataIndex: 'projectId',
                            directEdit: true,
                            title: '',
                            type: 'Input',
                            cellKey: `${record.id}-projectId`,
                            selectedKey: cellSelected,
                            onTap: (_, key) => setCellSelected(key),
                            handleSave: (e) => handleSave(e, 'projectId'),
                        }
                    }}
                />
                <Table.Column title="任务名称" dataIndex="title" width={250}
                    render={(value: number, row: Task) => {
                        return row?.title || ""
                    }}
                    onCell={(record: Task, idx) => {
                        return {
                            record,
                            editable: record.unpublished,
                            dataIndex: 'title',
                            directEdit: true,
                            title: '',
                            type: 'Input',
                            cellKey: `${record.id}-title`,
                            selectedKey: cellSelected,
                            onTap: (_, key) => setCellSelected(key),
                            handleSave: (e) => handleSave(e, 'title'),
                        }
                    }}
                />
                <Table.Column title="难度" dataIndex="scheduledCertainty" width={40}
                    render={(value: number, row: Task) => {
                        return `R${row?.scheduledCertainty}` || ""
                    }}
                    onCell={(record: Task, idx) => {
                        return {
                            record,
                            editable: false,
                            dataIndex: 'scheduledCertainty',
                            directEdit: true,
                            title: '',
                            type: 'Input',
                            cellKey: `${record.id}-scheduledCertainty`,
                            selectedKey: cellSelected,
                            onTap: (_, key) => setCellSelected(key),
                            handleSave: (e: Task) => handleSave(e, 'scheduledCertainty'),
                        }
                    }}
                />
                <Table.Column title="执行人" dataIndex="executorName" width={50}
                    render={(value: number, row: Task) => {
                        return row?.executorName || ""
                    }}
                    onCell={(record: Task, idx) => {
                        return {
                            record,
                            editable: false,
                            dataIndex: 'executorName',
                            directEdit: true,
                            title: '',
                            type: 'Input',
                            cellKey: `${record.id}-executorName`,
                            selectedKey: cellSelected,
                            onTap: (_, key) => setCellSelected(key),
                            handleSave: (e) => handleSave(e, 'executorName'),
                        }
                    }}
                />
                <Table.Column title="截止时间" dataIndex="dueTime" width={100}
                    render={(value: number, row: Task) => {
                        return row?.dueTime || ""
                    }}
                    onCell={(record: Task, idx) => {
                        return {
                            record,
                            editable: false,
                            dataIndex: 'dueTime',
                            directEdit: true,
                            title: '',
                            type: 'Input',
                            cellKey: `${record.id}-dueTime`,
                            selectedKey: cellSelected,
                            onTap: (_, key) => setCellSelected(key),
                            handleSave: (e) => handleSave(e, 'dueTime'),
                        }
                    }}
                />
            </Table>
        </div>
    )
}